<div class = "card card-container" [hidden]="isFirstLoading()">
    <div class="card-label px-1" *ngIf="hasLabel()">
        <mat-label> 
            <h3 translate>
                {{getTitle()}}
                <mat-icon   *ngIf           =   "reloadable"
                            class           =   "cursor unselectable"
                            (click)         =   "refreshTable()"    
                            [matTooltip]    =   "'table.reload' | translate">
                    refresh
                    
                </mat-icon>
            </h3>
        </mat-label>
    </div>

    <div id="table-header" *ngIf="!isFirstLoading()">

        <br>
        
        <div id="rows-filter" *ngIf="!emptyTable() && !no_filter_row">
            <mat-form-field appearance="outline" floatLabel="always" class="w-100 pr-2">
                <mat-label> {{ search_title | translate}} </mat-label>
                <input matInput [placeholder]=" search_placeholder | translate" [(ngModel)]="row_text_filter" (ngModelChange)="textFilter($event)">
                <mat-icon matPrefix class="mr-2">search</mat-icon>
            </mat-form-field>
        </div>

        <div *ngIf="!reload && !emptyTable()" [ngClass] = "(no_filter_row) ? 'columns-no-filter' : 'columns-filter'">
            <custom-select  #filterSelect
                            adaptive        =   "true"
                            [hidden]        =   "!filter_columns"
                            [values]        =   "generateColumns()"
                            [title_multiple]=   "filter_title"
                            multiple        =   "true"
                            (change)        =   "filterColumns($event)"
                            class           =   "ml-3"></custom-select>
        </div>
    </div>

    <div *ngIf   =   "can('create') && !reload && !isFirstLoading()" class="mx-2">
        
        <button     type    =   "button" 
                    class   =   "btn btn-outline-secondary create-button  mb-4 mr-3" 
                    (click) =   "table_create()" 
                    >
                    {{ create_text | translate }}
        </button>
        
    </div>

    <div *ngIf   =   "header_buttons?.length > 0 && !reload && !isFirstLoading()" class="mx-2">
        <ng-container *ngFor="let header_button of header_buttons">
        
            <button     *ngIf   =   "displayHeaderButton(header_button)"
                        type    =   "button" 
                        class   =   "btn btn-outline-secondary mb-4 mr-3" 
                        (click) =   "clickHeaderButton(header_button)">
                {{ header_button.name | translate }}
            </button>
            
        </ng-container>
    </div>

    <div *ngIf = "pdf_buttons?.length > 0 && !reload && !isFirstLoading()" class="mx-2">
        <ng-container *ngFor="let pdf_button of pdf_buttons">
        
            <button     *ngIf   =   "displayPdfButton(pdf_button)"
                        type    =   "button" 
                        class   =   "btn btn-outline-secondary mb-4 mr-3" 
                        (click) =   "clickPdfButton(pdf_button)">
                {{ pdf_button.name | translate }}
            </button>
            
        </ng-container>
    </div>

    <legenda [legends]="legenda" *ngIf="legenda && legenda.length > 0"></legenda>

    <div class="table-responsive" *ngIf="!reload && !emptyTable() && !isFirstLoading()" style="clear: both;">


        <table #customTable id="customTable" class="table table-striped">
            <thead>
                <tr *ngIf   =   "groups && groups.length > 0">
                    <th     *ngFor          =   "let group of groups"
                            [ngClass]       =   "{ 'group-col-left': !isFirstGroup(group), 'group-col-right' : !isLastGroup(group)}"
                            [hidden]        =   "getGroupSize( group ) == 0"
                            [attr.colspan]  =   "getGroupSize( group )"> 
                         {{ group.name | translate }}
                    </th>
                </tr>
                <tr >
                    <th *ngFor      =   "let col of visibleColumns; let i = index"
                        [ngClass]   =   "{ 'group-col-right' : isLastOfGroup(i)}"
                    > {{ col.name    | translate: col.translate_param }} </th>
                    <th *ngFor  =   "let but of buttons"       > {{ but.column  | translate }} </th>
                    <th *ngFor  =   "let ibut of icon_buttons" > {{ ibut.column | translate }} </th>

                    <th *ngIf   =   "can('update')" > {{update_text_title | translate}} </th>
                    <th *ngIf   =   "can('delete')" > {{delete_text_title | translate}} </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let row of rows; let row_i = index" [ngStyle]="rowStyleFilter(row_i, row)">
                    
                    <td     *ngFor      =   "let el of row; let i = index" 
                            [hidden]    =   "i == 0" 
                            [ngStyle]   =   "isLastOfGroup(i-1) && { 'border-right' : '2px solid #c1c1c1'}"
                            [ngClass]   =   "styleFilter(i-1, el)" 
                            (click)     =   "test(i-1, el)"
                            [innerHTML] =   "pipeData(i-1,el, row_i) | translate"> 
                    </td>

                    <td *ngFor="let but of buttons; let i = index"> 
                        <button     type="button" 
                                    *ngIf       =   "displayButton(but, row_i)"
                                    [hidden]    =   "!isButtonActive(but, row_i)"
                                    class="btn btn-outline-secondary" 
                                    (click)="call_action(but, row)"
                                    translate>
                                    <!--{{ pipeButtonData(row, i,but) | translate }}-->
                                    {{ getButtonName( but.name , row_i)  | translate}}
                        </button>
                    </td>

                    <td *ngFor="let ibut of icon_buttons; let i = index" > 
                        <button mat-icon-button [disabled] = "disableIconButton(ibut, row)"> 
                            <mat-icon
                                (click) = "call_action(ibut, row)" 
                                matTooltip = "{{ibut.tooltip | translate}}">
                                {{ibut.icon}}
                            </mat-icon>    
                        </button>
                    </td>
                    
                    <td *ngIf   =   "can('update')"> 
                        <button     type="button" 
                                    class="btn btn-outline-secondary" 
                                    (click)="table_update(row)" 
                                    translate>
                                    {{update_text | translate}}
                        </button>
                    </td>
                    <td *ngIf   =   "can('delete')"> 
                        <button     type="button" 
                                    class="btn btn-outline-danger" 
                                    (click)="table_delete(row)" 
                                    translate>
                                    {{delete_text | translate}}
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <div id="tab-footer" class="d-flex justify-content-between p-2" *ngIf="showPaginator()">
        <ngb-pagination     [ngStyle]       =   "{'opacity': showPages() ? '1' : '0' }"
                            class           =   "table-paginator"
                            [(page)]        =   "page" 
                            [pageSize]      =   "pageSize" 
                            [collectionSize]=   "getSize()"
                            [maxSize]       =   "getMaxSize()" 
                            rotate          =   "true" 
                            boundaryLinks   =   "true"
                            (pageChange)    =   "pageChange($event)">
        </ngb-pagination>
      
        <mat-select     class               =   "custom-select" 
                        [(ngModel)]         =   "pageSize"
                        (selectionChange)   =   "paginatorChange($event)">
            <mat-option [value]="6">
              <span translate> options.paginator.six </span>   
            </mat-option>
            <mat-option [value]="8">
                <span translate> options.paginator.eight </span>   
            </mat-option>
            <mat-option [value]="10">
                <span translate> options.paginator.ten </span>   
            </mat-option>
            <mat-option [value]="12">
                <span translate> options.paginator.twelve </span>   
            </mat-option>
        </mat-select>
      </div>

        <ng-container *ngIf="chartsConf && !reload && !emptyTable() && !isFirstLoading()">
            <div id="chart-container" class="d-flex">
                <cq-charts  [hidden]            =   "!rows || rows?.length <= 0 || !visibleColumns || visibleColumns?.length <= 0"
                            *ngFor              =   "let chart of chartsConf"
                            class               =   "overflow-auto mt-3"
                            [conf]              =   "chart"
                            [visibleColumns]    =   "visibleColumns"
                            [unfilteredColumns] =   "columns"
                            [rows]              =   "rows"></cq-charts>    
            </div>
        </ng-container>    
    
    <div class="table-responsive" *ngIf="!reload && emptyTable() && !isFirstLoading()" style="clear: both;">
        <p class="text-center w-100"> 
            {{ no_data | translate}} 
        </p>
    </div>
    <div class="table-responsive" *ngIf="reload && !isFirstLoading()" style="clear: both;">
        <p class="text-center w-100"> 
            {{ loading_data | translate}} 
        </p>
    </div>
</div>          

